<script setup>
import Loading from '@/components/loading.vue';
import { get_trait } from '@/services/packages';
import { get_intervention_progress, get_trait_intervention } from '@/services/intervention';
import emptyCard from '@/components/emptyCard.vue';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import childInfoCard from '@/components/childInfoCard.vue';
import { retrieve_child } from '@/services/child';
import card_header from '@/components/card_header.vue';
import contentCard from './contentCard.vue'
import activityCard from './activityCard.vue'
import { swalError } from '@/helper';

const route = useRoute()
const trait_config = ref()
const isLoading = ref(true)
const activities = ref([])
const intervention = ref({})
const child = ref({})
const age_group_term = ref({})
onMounted(async ()=>{
  let response = await get_trait(route.params.id)
  let child_response = await retrieve_child(route.params.child_id)
  child.value = child_response.result.data.data
  trait_config.value = response.result.data
  let intervention_response = await get_trait_intervention({trait: route.params.id, child: route.params.child_id})
  if (!response.error){
    if (response.data !== null){
      parseActivity(intervention_response.result.intervention.included)
      intervention.value = intervention_response.result.intervention.data
      checkActivityStatus(intervention_response.result.intervention.data?.id)
    }
    age_group_term.value = intervention_response.result.term
  }else{
    swalError('Error retrieving intervention data')
  }
  isLoading.value = false
})

function parseActivity(items){
  if (!items){
    return 1
  }
  let temp_activities = items.map((item)=>{
    if (item.type == "intervention_activity"){
      return {
        title: item.attributes.title,
        id: item.id,
      }
    }
  })

  temp_activities = temp_activities.filter(item => item) // remove null 
  activities.value = temp_activities
}

// checking status for particular activity
async function checkActivityStatus(intervention_id){
  let progress_response = await get_intervention_progress(intervention_id, child.value.id)
  if (!progress_response.error){
    progress_response.result.data.map((item)=>{
      let index = activities.value.findIndex(activity => activity.id == item.attributes.intervention_activity_id)
      if (index !== -1){
        activities.value[index] = {
          ...activities.value[index], 
          isCompleted: true,
          intervention_progress_id: item.id,
          date_completed: item.attributes.updated_at
        }
      }
    })
  }
}

</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Intervention"/>
    
    <Loading v-if="isLoading" />
    <div v-else>
      <template v-if="!intervention?.id">
        <!-- Child Info -->
        <childInfoCard class="col-md-6" :child="child"/>
        <div class="card">
          <div class="card-body">
            <emptyCard />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <!-- Child Info -->
          <div class="col-md-6">
            <childInfoCard :child="child"/>
          </div>
          <!-- Intervention Description -->
          <div class="col-12 col-md-6">
            <div class="card">
              <card_header 
                :is_narrow="true" 
                title='Intervention Description'
                :extra_class="'justify-content-between'"
              ></card_header>
              <div class="card-body">
                <p>{{ intervention.attributes.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class='col-12'>
          
          <!-- PDF Viewer -->
          <div class="card">
            <card_header 
              :is_narrow="true" 
              :title="'Trait Name : ' + trait_config?.attributes.name"
              :extra_class="'justify-content-between'"
            >
              <div class=" me-2">
                <div class="chart-card-info me-2">
                  <p class="mb-0">
                    Current Age Group :
                    <span>{{ age_group_term?.name || '-' }}</span>
                  </p>
                </div>
              </div>
            </card_header>
            
            <contentCard :intervention="intervention" />
          </div>
  
          <!-- Activity -->
          <activityCard :trait_config="trait_config" 
            :child="child"
            :activities="activities"
            :intervention="intervention"
            :age_group_term="age_group_term"
          />
        </div>
      </template>
    </div>
  </div>
</template>